import { usePost } from '../../../hooks/useApi';

interface MarkAbsentPayload {
  date: string;
  note: string | null;
  scheduleId?: number;
}

interface MarkAbsentResponse {
  success: boolean;
  message: string;
}

/**
 * Hook for marking a student as absent
 * @param studentId - The ID of the student
 * @returns The mutation result
 */
export const useMarkAbsent = (studentId: number) => {
  return usePost<MarkAbsentResponse, MarkAbsentPayload>(
    `/v1/auth/dashboard/attendance/student/${studentId}/absence`,
    {
      onSuccess: () => {
        // Invalidate related queries to refresh data
      },
    }
  );
};
